import { render, staticRenderFns } from "./RegStatusModal.vue?vue&type=template&id=507ccc64&"
import script from "./RegStatusModal.vue?vue&type=script&lang=js&"
export * from "./RegStatusModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports